class PaginationInfo {
    constructor({ total_pages }) {
        this.totalPages = total_pages
    }
}

export { PaginationInfo }
